import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import NumberStepper from "core/inputs/number-stepper/NumberStepper";
import StepHeader from "./StepHeader";

// Candidate recruitment interviews conducted this week (≥ 0).
// Unrelated to annual review interviews — the label removes the ambiguity.
const InterviewsStep = ({ value, onChange }) => (
  <div className="faf-step">
    <StepHeader>
      <FormattedMessage
        id="tools_manager_faf_interviews_title"
        defaultMessage="Combien d'entretiens de recrutement as-tu réalisés ?"
      />
    </StepHeader>
    <p className="faf-field-label">
      <FormattedMessage
        id="tools_manager_faf_interviews_field_label"
        defaultMessage="Nombre d'entretiens de recrutement"
      />
    </p>
    <NumberStepper
      id="faf-interviews"
      dataTestId="faf-interviews-stepper"
      value={value}
      onChange={onChange}
      min={0}
    />
  </div>
);

InterviewsStep.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default InterviewsStep;
